import React from 'react';
import SectorPage from '../SectorPage/SectorPage';

const SolutionsPro = () => {
  const sectorData = {
    title: "Solutions professionnelles",
    subtitle: "Accélérez votre prospection B2B",
    intro: "Qu'il s'agisse de gestion de flotte, de maintenance ou de gestion documentaire, les solutions professionnelles doivent démontrer leur efficacité opérationnelle. Utiliser le vocabulaire métier, fournir des références sectorielles, des simulateurs d'économie et adresser les bons interlocuteurs métier permet une prospection plus ciblée.",
    name: "Solutions professionnelles",
    titleContext: "du secteur des solutions professionnelles",
    responseContext: "des acteurs des solutions professionnelles",
    expertContext: "du secteur des entreprises de solutions professionnelles"
  };

  return <SectorPage sector={sectorData} />;
};

export default SolutionsPro; 